export default __webpack_public_path__ + "static/media/hlg1.95acd334.png";